import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/signature_steps_tutorial_image.png")